import request from '@/utils/request'
import URL from './urlTranslator'

export function getRolePrivilegeTree(roleUuid) {
  const params = { roleUuid }
  return request({
    url: URL.sys.rolePrivileges,
    method: 'get',
    params
  })
}

export function getRoleReprotPrivilegeTree(roleUuid) {
  const params = { roleUuid }
  return request({
    url: URL.sys.roleReprotPrivilege,
    method: 'get',
    params
  })
}

export function getTenantPrivilegeTree() {
  return request({
    url: URL.sys.tenantPrivileges,
    method: 'get'
  })
}

export function saveReportPrivilege(requestBody) {
  return request({
    url: URL.sys.saveReportPrivilege,
    method: 'post',
    data: requestBody
  })
}

// 校验用户权限
export function checkUserPrivilege(params) {
  return request({
    url: URL.sys.checkUserPrivilege,
    method: 'get',
    params
  })
}
